import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "selected-text" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "dropdown-options"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "dropdown-text" }

import { ref, onMounted, watch, onUnmounted, computed } from 'vue'
import { DateSelection } from '@/interfaces/dateselection.interface'
import SvgDisplay from '../atoms/SvgDisplay.vue'
import IconChevroneUpMedium from '@/design-system/assets/icons/IconChevroneUpMedium.vue'
import { useI18n } from 'vue-i18n'
import { useTimeSelection } from '@/composables/useTimeRange'
import { storeToRefs } from 'pinia'
import { LocaleString } from '@/components/types'
import IconCheck from '@/design-system/assets/icons/IconCheck.vue'
import { FeatureType, useFilters } from '@/composables/useFilters'


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownCalendar',
  props: {
    dateSelection: {},
    defaultSelection: {}
  },
  emits: ["presentCalendar"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const selectedOption = ref<{ name: string; title: LocaleString } | null>(null)
const isOpen = ref(false)
const dropdownRef = ref<HTMLElement | null>(null)
const timeSelection = useTimeSelection()
const { absoluteRange, selectionName, timeRangeFormat } = storeToRefs(timeSelection)
const { t, locale } = useI18n()
const enabled = computed(() => props.dateSelection.length > 1)

const filters = useFilters(FeatureType.AggregateAnalysis)
const onlyBusinessDays = computed(() => !!filters.current?.onlyBusinessDays)
const onlyBusinessHours = computed(() => !!filters.current?.onlyBusinessHours)

const selectedTimeAndBusinessDays = computed<string>(() => {
  const parts: string[] = []

  if (onlyBusinessHours.value) {
    parts.push(t('general__text__businesshours'))
  }

  if (onlyBusinessDays.value) {
    parts.push(t('general__text__businessdays').toLocaleLowerCase())
  }

  return parts.length > 0 ? `(${parts.join(', ')})` : ''
})

const toggleDropdown = () => {
  isOpen.value = !isOpen.value
}

const selectOption = (option: DateSelection) => {
  selectedOption.value = option
  isOpen.value = false
  if (option.range) {
    timeSelection.set(option.name, option.range)
  }
  if (option.name === 'custom') {
    emit('presentCalendar')
  }
}
const handleClickOutside = (event: MouseEvent) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target as Node)) {
    isOpen.value = false
  }
}

watch(
  [selectionName, absoluteRange],
  ([name, range]) => {
    if (name && range) {
      const matchedSelection = props.dateSelection.find((selection) => selection.name === name)
      if (matchedSelection) {
        if (matchedSelection.name !== 'custom') {
          selectedOption.value = matchedSelection
        } else {
          selectedOption.value = {
            name: 'custom',
            title: timeRangeFormat.value ?? { en: 'Custom', sv: 'Anpassad' }
          }
        }
      }
    }
  },
  { immediate: true }
)

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
  const range = props.dateSelection.find(
    (selection) => selection.name === props.defaultSelection
  )?.range
  if (props.defaultSelection && range) {
    timeSelection.set(props.defaultSelection, range)
  }
})
onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "dropdownRef",
    ref: dropdownRef
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["selected-option", { active: isOpen.value, disabled: !enabled.value }]),
      onClick: toggleDropdown
    }, [
      _createElementVNode("span", _hoisted_1, _toDisplayString(selectedOption.value?.title[_unref(locale)] || 'Select an option') + " " + _toDisplayString(selectedTimeAndBusinessDays.value), 1),
      (enabled.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createVNode(IconChevroneUpMedium, {
              class: _normalizeClass(["icon", { active: isOpen.value }])
            }, null, 8, ["class"])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (isOpen.value && enabled.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateSelection, (option, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["dropdown-item", { 'selected-item': selectedOption.value?.name === option.name }]),
              onClick: ($event: any) => (selectOption(option))
            }, [
              (option.icon)
                ? (_openBlock(), _createBlock(SvgDisplay, {
                    key: 0,
                    src: option.icon[_unref(locale)],
                    style: {
            width: '24px',
            height: '24px',
            marginRight: '8px'
          }
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_5, _toDisplayString(option.title[_unref(locale)]), 1),
              (selectedOption.value?.name === option.name)
                ? (_openBlock(), _createBlock(IconCheck, {
                    key: 1,
                    class: "checkmark"
                  }))
                : _createCommentVNode("", true)
            ], 10, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})